import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Snackbar,
  Grid
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import MailIcon from '@material-ui/icons/Mail';
import PrintIcon from '@material-ui/icons/Print';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import SignatureCanvas from 'react-signature-canvas'
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import CiktiSmsGonder from 'src/components/PrintSmsSend';
import axios from 'src/utils/axios';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { getUser } from 'src/utils/Common';
import { async } from 'validate.js';
import Alert from 'src/components/Alert';
import DescriptionIcon from '@material-ui/icons/Description';
import ErrorMessage from 'src/components/ErrorMessage';

const useStyles = makeStyles((theme) => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700]
    },
    width: '100%'
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  content: {
    minHeight: 430,
  },
}));

function Yazdir({
  className, ReceiptNo, readonly, tasks
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [ciktiSms, setCiktiSms] = useState(false);
  const [ciktiTip, setCiktiTip] = useState(0);
  const [ciktiTipTxt, setCiktiTipTxt] = useState('');
  const SessionUser = getUser();
  const [loading, setLoading] = useState(false);
  const [emailAddress, setEmailAddress] = useState('');
  const [emailAddressPopUp, setEmailAddressPopup] = useState(false);
  const [SingaturePopUp, setSingaturePopUp] = useState(false);
  const [SingatureCPopUp, setSingatureCPopUp] = useState(false);
  const [Sign, setSign] = useState();
  const [SignC, setSignC] = useState();
  const [ResponseType, setResponseType] = useState('success');
  const [ResponseDsc, setResponseDsc] = useState('');
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [domain, setDomain] = useState('');
  let DurumFisCiktiKontrol = false;
  let DurumRevizyonKartiKontrol = false;
  let DurumEvdeYokKontrol = false;
  const isOnline = useSelector((state) => state.status?.isOnline);

  const YazdirData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();

  const durumKodu = parseInt(YazdirData[0].LatestStatus) || 0;

  const handleCiktiSmsClose = () => {
    setCiktiSms(false);
  };
  const YazdirMerkezeGonderData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();


  DurumFisCiktiKontrol = false;
  DurumRevizyonKartiKontrol = false;
  DurumEvdeYokKontrol = false;

  const getDomainByTenant = async (workOrderId) => {
    try {
      setLoading(true);
      const response = await axios
        .get(`/getDomain/${workOrderId}`);
      if (response.data?.length > 0) {
        return response.data;
      }

    }
    catch (error) { }
    finally {
      setLoading(false);
    }
  }


  useEffect(() => {
    const getDomainByTenantAsync = async () => {
      var domain = await getDomainByTenant(ReceiptNo);
      if (domain) {
        var finalDomain = `${domain}nps/SiriusServicePaper/html/`
        setDomain(finalDomain);
      }
    }

    getDomainByTenantAsync();
  }, [])

  // React.useEffect(() => {
  if (YazdirMerkezeGonderData.length === 0) {
    return null;
  }
  if ([4, 45, 18, 11, 23, 31].indexOf(parseInt(YazdirMerkezeGonderData[0].LatestStatus)) !== -1) {
    DurumFisCiktiKontrol = true;
  }

  if ([10, 12, 46, 38, 11].indexOf(parseInt(YazdirMerkezeGonderData[0].LatestStatus)) !== -1) {
    DurumRevizyonKartiKontrol = true;
  }
  if (YazdirMerkezeGonderData[0].LatestStatus === 51) {
    DurumEvdeYokKontrol = true;
  }


  if (DurumFisCiktiKontrol === false
    && DurumRevizyonKartiKontrol === false
    && DurumEvdeYokKontrol === false
    && [23, 15, 31, 32].indexOf(parseInt(YazdirMerkezeGonderData[0].LatestStatus)) === -1
  ) {
    DurumFisCiktiKontrol = true;
  }


  if ([21, 22, 33, 42].indexOf(parseInt(YazdirMerkezeGonderData[0].DurumKodu)) !== -1) {
    DurumFisCiktiKontrol = false;
    DurumRevizyonKartiKontrol = false;
    DurumEvdeYokKontrol = false;
  }

  const Onizleme = (event, ciktiTipi) => {
    let Link = process.env.NODE_ENV !== "development" ? domain && domain !== '' ? domain : process.env.REACT_APP_CIKTI_URL : process.env.REACT_APP_CIKTI_URL;
    Link = `${Link}ServicePaper.html?WorkId=${YazdirMerkezeGonderData[0].WorkOrderGuid}` + '&TenantId=' + SessionUser.TenantId + '&LanguageId=' + localStorage.getItem('i18nextLng');
    event.persist();
    window.open(Link);
    event.persist();
  };

  const Quotation = (event, ciktiTipi) => {
    UpdateWorkOrderStatusForQuotation();

    let Link = process.env.REACT_APP_CIKTI_URL;
    Link = `${Link}QuotationReport.html?WorkOrderId=${YazdirMerkezeGonderData[0].ReceiptNo}` + '&TenantId=' + SessionUser.TenantId + '&LanguageId=' + localStorage.getItem('i18nextLng');
    event.persist();
    window.open(Link);
    event.persist();
  };

  const QuotationPreview = (event, ciktiTipi) => {
    let Link = process.env.REACT_APP_CIKTI_URL;
    Link = `${Link}QuotationReport.html?WorkOrderId=${YazdirMerkezeGonderData[0].ReceiptNo}` + '&TenantId=' + SessionUser.TenantId + '&LanguageId=' + localStorage.getItem('i18nextLng');
    event.persist();
    window.open(Link);
    event.persist();
  };

  const UpdateWorkOrderStatusForQuotation = () => {
    axios
      .post('/SetWorkOrderStatusForQuotation/' + ReceiptNo)
      .then(response => {
        if (response.data == "") {
          setResponseType('success');
          setResponseDsc(t('success_message'));
          setOpenSnackbar(true);
        } else {
          setResponseType('error');
          setResponseDsc(response.data.ErrorMessage);
          setOpenSnackbar(true);
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const SaveSign = (ReceiptNo) => {
    const canvas = document.getElementById('Sign');

    // Get the image data from the canvas
    const imageData = canvas.toDataURL(); // This will return a data URL (Base64-encoded string)

    // Extract the Base64 part from the data URL
    MerkezeGonder(imageData, ReceiptNo, 'Technician Signature');
  }

  const SaveSignC = (ReceiptNo) => {
    const canvas = document.getElementById('SignC');

    // Get the image data from the canvas
    const imageData = canvas.toDataURL(); // This will return a data URL (Base64-encoded string)
    MerkezeGonder(imageData, ReceiptNo, 'Customer Signature');

  }

  const MerkezeGonder = async (img, ReceiptNo, SignatureType) => {
    const base64String = img.split(',')[1];
    const data = {
      Title: SignatureType,
      MIMEType: "image/png",
      WorkOrderId: ReceiptNo.toString(),
      FileType: 1,
      FileData: base64String
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };


    if (window.navigator.onLine) {
      await axios.post('/FileImportExport/SiriusFileUpload', data, config)
        // eslint-disable-next-line
        .then(response => {
          // onClose(dataUri);
          setLoading(false);
        }).catch((error) => {
          // saveFotograf(ReceiptNo, dataUri, DosyaTipi, DosyaTipiText, FileType);
          setLoading(false);
          // onClose(dataUri);
        });
    } else {
      // saveFotograf(ReceiptNo, dataUri, DosyaTipi, DosyaTipiText, FileType);
      setLoading(false);
      // onClose(dataUri);
    }
    return
    /*  urltoFile(dataUri, DosyaTipiText, 'image/png')
       .then(async (filelar) => {
         const file = filelar;
         const FileType = file.type;
 
         let base64Result = '';
 
         const resizedImage = await compress.compress([file], {
           size: 0.3,
           quality: 1,
           maxWidth: 1920,
           maxHeight: 1920,
           resize: true
         });
         const img = resizedImage[0];
         base64Result = img.data;
 
 
         setLoading(true);
         // now upload
         const data = {
           Title: 'DosyaTipiText',
           MIMEType: FileType,
           WorkOrderId: 1,
           FileType: 1,
           FileData: abc
         };
         const config = {
           headers: { 'Content-Type': 'application/json' }
         };
 
 
         if (window.navigator.onLine) {
           await axios.post('/FileImportExport/SiriusFileUpload', data, config)
             // eslint-disable-next-line
             .then(response => {
               onClose(dataUri);
               setLoading(false);
             }).catch((error) => {
               saveFotograf(ReceiptNo, dataUri, DosyaTipi, DosyaTipiText, FileType);
               setLoading(false);
               onClose(dataUri);
             });
         } else {
           saveFotograf(ReceiptNo, dataUri, DosyaTipi, DosyaTipiText, FileType);
           setLoading(false);
           onClose(dataUri);
         }
       }); */
  };


  const sendEmailWarning = (ReceiptNo, CustomerFullName, CustomerEmail) => {
    confirmAlert({
      message: t('email_confirm').replace('@Musteri', CustomerFullName).replace('@XMusteriEmail', CustomerEmail),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => sendEmailYes(ReceiptNo, CustomerEmail)
        },
        {
          label: t('Hayir'),
          onClick: () => { }
        }
      ]
    });
  };

  const confirmOkey = (msg) => {
    confirmAlert({
      message: msg,
      buttons: [
        {
          label: t('Tamam'),
          onClick: () => { }
        }
      ]
    });
  };

  const sendEmailYes = (ReceiptNo, Email) => {
    const data = {
      ReceiptNo,
      Type: 2,
      Email,
      EmployeeId: parseInt(SessionUser.TechnicianId)
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading(true);
    axios.post('/InsertWorkOrderNotification', data, config)
      .then((response) => {
        confirmOkey(t('lblBasarili'));
        setLoading(false);
      }).catch((error) => {
        confirmOkey(t('Error') + error.message);
        setLoading(false);
      });
  };

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader title={t('yazdir_title')} />
      <Divider />
      {isOnline ? (
        <CardContent className={classes.content}>
          {
            loading
              ? (
                <CircularProgress
                  status="loading"
                  style={{ marginLeft: '50%' }}
                />
              )
              : <div />
          }
          <Snackbar
            open={openSnackbar}
            autoHideDuration={5000}
            onClose={handleSnackbarClose}
          >
            <Alert
              onClose={handleSnackbarClose}
              message={ResponseDsc}
              variant={ResponseType}
            />
          </Snackbar>
          <div className={classes.wrapper}>
            <div className={classes.wrapper}>
              {DurumFisCiktiKontrol && (
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                    onClick={(e) => Onizleme(e, 1)}
                    disabled={[21, 22, 33, 42].includes(durumKodu)}
                    endIcon={<PrintIcon>Yazdır</PrintIcon>}
                  >
                    {t('Fis_ciktisi_onizleme')}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                    onClick={() => {
                      setCiktiTip(1);
                      setCiktiTipTxt('Fiş Çıktısı');
                      setCiktiSms(true);
                    }}
                    disabled={[21, 22, 33, 42].includes(durumKodu)}
                    endIcon={<SendIcon>Yazdır</SendIcon>}
                  >
                    {t('Fis_ciktisi_Sms_Gonder')}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                    onClick={() => {
                      setEmailAddress(YazdirMerkezeGonderData[0].CustomerEmail);
                      setEmailAddressPopup(true);
                    }}
                    disabled={[21, 22, 33, 42].includes(durumKodu)}
                    endIcon={<MailIcon />}
                  >
                    {t('Fis_ciktisi_Email_Gonder')}
                  </Button>
                  {(SessionUser.TenantId === 37 || SessionUser.TenantId === 61 || SessionUser.TenantId === 82 || SessionUser.TenantId === 48) ? (
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.submitButton}
                      onClick={(e) => Quotation(e, 1)}
                      endIcon={<DescriptionIcon></DescriptionIcon>}
                    >
                      {t('lblQuotationSend')}
                    </Button>
                  ) : (
                    <Grid item xs={12} sm={3} lg={3} align="right">
                    </Grid>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                    onClick={() => {
                      setSingaturePopUp(true);
                    }}
                    disabled={[21, 22, 33, 42].includes(durumKodu)}
                    endIcon={<MailIcon />}
                  >
                    {t('Add Signature')}
                  </Button>
                </div>
              )}
            </div>
            <div className={classes.wrapper}>
              {DurumRevizyonKartiKontrol && (
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => Onizleme(e, 3)}
                    disabled={[21, 22, 33, 42].includes(durumKodu)}
                    className={classes.submitButton}
                    endIcon={<PrintIcon>Yazdır</PrintIcon>}
                  >
                    {t('revizyon_onizleme')}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setCiktiTip(3);
                      setCiktiTipTxt('Revizyon Kartı');
                      setCiktiSms(true);
                    }}
                    disabled={[21, 22, 33, 42].includes(durumKodu)}
                    className={classes.submitButton}
                    endIcon={<SendIcon>Revizyon Kartı</SendIcon>}
                  >
                    {t('revizyon_Sms_Gonder')}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </CardContent>
      ) : (
        <CardContent>
          <ErrorMessage message={t('Offline_Message')} />
        </CardContent>
      )}
      <CardActions className={classes.actions} />
      <CiktiSmsGonder
        onClose={handleCiktiSmsClose}
        forceOpen={() => setCiktiSms(true)}
        ReceiptNo={ReceiptNo}
        open={ciktiSms}
        ciktiTip={ciktiTip}
        ciktiTipTxt={ciktiTipTxt}
      />
      <Dialog
        open={emailAddressPopUp}
        fullWidth
        maxWidth="sm"
        onClose={() => setEmailAddressPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblEmail')}</DialogTitle>
        <DialogContent>
          <TextField
            size="small"
            id="Email"
            autoComplete="no"
            value={emailAddress}
            onChange={(event) => setEmailAddress(event.target.value)}
            fullWidth
            label={t('lblEmail')}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setEmailAddressPopup(false)}
            color="secondary"
          >
            {t('Hayir')}
          </Button>
          <Button
            onClick={() => {
              setEmailAddressPopup(false);
              sendEmailWarning(YazdirMerkezeGonderData[0].ReceiptNo, YazdirMerkezeGonderData[0].ContactName, emailAddress);
            }}
            color="primary"
          >
            {t('Evet')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={SingaturePopUp}
        fullWidth
        maxWidth="sm"
        onClose={() => setSingaturePopUp(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('Add Technician Signature')}</DialogTitle>
        <DialogContent>
          <SignatureCanvas penColor='black'
            backgroundColor='white'
            ref={data => setSign(data)}
            canvasProps={{ width: 500, height: 200, className: 'sigCanvas', id: 'Sign' }} />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              SaveSign(YazdirMerkezeGonderData[0].ReceiptNo);
              setSingaturePopUp(false);
              setSingatureCPopUp(true);

            }}
            color="secondary"
          >
            {t('Save')}
          </Button>
          <Button
            onClick={() => {
              Sign.clear();
            }}
            color="primary"
          >
            {t('Clear')}
          </Button>
          <Button
            onClick={() => {
              setSingaturePopUp(false);
            }}
            color="primary"
          >
            {t('Cancel')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={SingatureCPopUp}
        fullWidth
        maxWidth="sm"
        onClose={() => setSingatureCPopUp(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('Add Customer Signature')}</DialogTitle>
        <DialogContent>
          <SignatureCanvas penColor='black'
            backgroundColor='white'
            ref={data => setSignC(data)}
            canvasProps={{ width: 500, height: 200, className: 'sigCanvas', id: 'SignC' }} />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              SaveSignC(YazdirMerkezeGonderData[0].ReceiptNo);
              setSingatureCPopUp(false)

            }}
            color="secondary"
          >
            {t('Save')}
          </Button>
          <Button
            onClick={() => {
              SignC.clear();
            }}
            color="primary"
          >
            {t('Clear')}
          </Button>
          <Button
            onClick={() => {
              setSingatureCPopUp(false);
            }}
            color="primary"
          >
            {t('Cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>

  );
}

Yazdir.propTypes = {
  className: PropTypes.string
};

export default connect((state) => ({ tasks: state.tasks1 }))(Yazdir);
